module.exports = __webpack_public_path__ + "img/icon5-1.7a2f897c.svg";